import { graphql } from "@/gql";

export const MY_COMPANY_CONTRACT_STATUS = graphql(`
  query MyCompanyContractStatus {
    myCompanyContractStatus {
      needsSignature
      deliveryEmail
      pending {
        versionId
        typeSlug
        typeName
        title
        acknowledgementMode
        isBlocking
        content
        fields {
          key
          label
          fieldType
          required
          width
          placeholder
          helpText
          section
          sectionTitle
        }
        countries
        prefill
      }
    }
  }
`);

export const CONTRACT_TYPES = graphql(`
  query ContractTypes {
    contractTypes {
      id
      slug
      name
      description
      acknowledgementMode
      isBlocking
      requiresReacknowledgement
      order
      versionCount
      currentVersion {
        id
        version
      }
      versions {
        id
        version
        title
        content
        publishAt
        createdAt
        isPublished
        isScheduled
        isCurrent
        acknowledgementCount
      }
    }
  }
`);

export const COUNTRIES = graphql(`
  query Countries {
    countries {
      id
      name
      code
      isActive
      order
    }
  }
`);

export const TEMPLATE_PLACEHOLDERS = graphql(`
  query TemplatePlaceholders {
    templatePlaceholders {
      key
      label
      example
    }
  }
`);

export const CONTRACT_REFILL_FORM = graphql(`
  query ContractRefillForm($contractTypeSlug: String!) {
    contractRefillForm(contractTypeSlug: $contractTypeSlug) {
      typeSlug
      typeName
      title
      currentVersion
      deliveryEmail
      countries
      prefill
      fields {
        key
        label
        fieldType
        required
        width
        placeholder
        helpText
        section
        sectionTitle
      }
    }
  }
`);
